import { Language } from '../ts/customTypes';
import { Pages } from '../ts/customTypes';

// Background

// Icons
import IconBenefits from '../icons/content/benefits.svg';

// Content Images
import processStepTeileidentifikation1Svg from '../content/it/process-parts-identification-step1.svg';
import processStepTeileidentifikation2Svg from '../content/it/process-parts-identification-step2.svg';
import processStepTeileidentifikation3Svg from '../content/it/process-parts-identification-step3.svg';
import processStepTeileidentifikation4Svg from '../content/it/process-parts-identification-step4.svg';

import processStepLagerergaenzung1Svg from '../content/it/process-storage-step1.svg';
import processStepLagerergaenzung2Svg from '../content/it/process-storage-step2.svg';
import processStepLagerergaenzung3Svg from '../content/it/process-storage-step3.svg';
import processStepLagerergaenzung4Svg from '../content/it/process-storage-step4.svg';

import contactImage from '../content/mail-contact.png';
import testimonial1 from '../content/testimonial1.jpg';
import testimonial2 from '../content/testimonial2.jpg';
import { IconBestellschnittstelle } from '../../lib/components/content/IconBestellschnittstelle';
import { IconKatalogschnittstelle } from '../../lib/components/content/IconKatalogschnittstelle';
import { IconVerfuegbarkeitsschnittstelle } from '../../lib/components/content/IconVerfuegbarkeitsschnittstelle';
import { IconNettopreisschnittstelle } from '../../lib/components/content/IconNettopreisschnittstelle';

import landingpageSmallImage1 from '../content/landingpage-img-1.webp';
import landingpageSmallImage2 from '../content/landingpage-img-2.webp';
import landingpageBigImage from '../content/image-landingpage-big.jpg';

import imageKatalogschnittstelle from '../content/image-katalogschnittstelle.jpg';
import imageBestellschnittstelle from '../content/image-bestellschnittstelle.jpg';
import imageNettopreisschnittstelle from '../content/image-nettopreisschnittstelle.jpg';
import imageVerfuegbarkeitsschnittstelle from '../content/image-verfuegbarkeitsschnittstelle.jpg';
import flag from '../flags/flag-it.svg';

export const it: Language = {
    id: 'IT',
    languageName: 'Italiano',
    flagUrl: flag,
    headerHeading: 'eProcurement',
    backToLandingPageLabel: 'Panoramica',
    infolayer: {
        text: (
            <>
                <p>Siamo lieti che desideriate saperne di più sulle interfacce di eProcurement di OMNIplus.</p>
                <p>
                    Il sito Web è ottimizzato per la visualizzazione su computer desktop o tablet. La visualizzazione su
                    dispositivo mobile non è purtroppo possibile.
                </p>
                <p>
                    Tramite l'indirizzo Web di questa pagina è possibile aprire i contenuti anche su altri dispositivi.
                    Basta inviare l'indirizzo di questa pagina a un tablet o computer. Fate clic sul seguente link per
                    copiare l'indirizzo web negli appunti:
                </p>
            </>
        ),
        button: 'Copia il link negli appunti',
    },
    [Pages.LANDINGPAGE]: {
        headline: 'Processo di approvvigionamento',
        headlineWidth: 620,
        buttonContact: 'Contatti',
        buttonTestimonials: 'Feedback dei clienti',
        tooltips: {
            availability: 'Interfaccia di\ndisponibilità',
            catalogue: 'Interfaccia del\ncatalogo',
            identification: 'Identificazione dei componenti',
            order: "Interfaccia d'ordine",
            price: 'Interfaccia del\nprezzo netto',
            storage: 'Disponibilità\ndi parti\ndi ricambio comuni',
        },
        background: '',
        images: {
            leftUpper: landingpageSmallImage1,
            leftLower: landingpageSmallImage2,
            big: landingpageBigImage,
        },
    },
    testimonialsPage: {
        headline: 'Feedback dei clienti',
        headlineWidth: 420,
        testimonials: [
            {
                name: 'Jens-Uwe Mentel',
                imageUrl: testimonial1,
                job: 'Collaboratore tecnico presso Usedomer Bäderbahn GmbH',
                quotes: [
                    '«La configurazione della nuova interfaccia per COSware funziona perfettamente. Questo ci permette di inserire e ordinare i ricambi nel sistema in modo più rapido.»',
                ],
            },
            {
                name: 'Mirano Bitici',
                job: 'Head of Purchasing presso Stuttgarter Straßenbahnen AG',
                quotes: [
                    '«In brevissimo tempo è stato elaborato un progetto per realizzare il collegamento del nostro sistema di approvvigionamento con OMNIplus.»',
                    '«È bene sottolineare la procedura pragmatica e mirata.»',
                    '«Oggi, nel settore acquisti e nelle nostre officine beneficiamo di minori costi di approvvigionamento.»',
                ],
            },
            {
                name: 'Richard Schallmoser',
                imageUrl: testimonial2,
                job: 'Purchasing department presso Holding Graz – Kommunale Dienstleistungen GmbH',
                quotes: [
                    "«Grazie all'implementazione abbiamo ottimizzato il processo di approvvigionamento anche sul campo. Questo vantaggio per noi è stato altrettanto importante quanto le interfacce stesse.»",
                    '«Già in brevissimo tempo il collegamento si è dimostrato così efficace da non poterne fare a meno.»',
                ],
            },
        ],
        footer: {
            // #Einsatz-Kundenfeedback-eProcurement-Click-Explainer#
            headline: 'Le nostre interfacce sono in uso presso:',
            companies: [
                'Stuttgarter Straßenbahnen AG',
                'Holding Graz – Kommunale Dienstleistungen GmbH',
                'Regionalbus Leipzig GmbH',
                'Usedomer Bäderbahn GmbH',
                'EBS Public Transportation B. V.',
            ],
        },
    },
    contactPage: {
        headline: 'Contatti',
        headlineWidth: 250,
        texts: [
            "I processi sono al centro dell'attenzione quando si implementano le interfacce di e-procurement: per questo vi supportiamo nel progetto di collegamento personalizzato per la digitalizzazione degli approvvigionamenti.",
            "Potete contattarci all'indirizzo: ",
        ],
        email: 'omniplus-eprocurement@daimlertruck.com',
        imageUrl: contactImage,
        stepsHeadline: 'Normalmente ogni progetto di collegamento si svolge in quattro fasi:',
        steps: ['Lancio', 'Ideazione', 'Implementazione', 'Avvio'],
        text: (
            <p>
                Dopo aver preso contatto, in un primo incontro (lancio) sarà definito in che modo l'eProcurement può
                potenzialmente supportarvi nel processo di approvvigionamento. Successivamente, nella fase di ideazione
                viene esaminato come questo possa essere implementato e quanto sia complesso o costoso. Dopo una fase di
                collaudo positiva è possibile passare al nuovo processo di approvvigionamento.
            </p>
        ),
    },
    infoPages: {
        [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: {
            headline: 'Interfaccia di disponibilità',
            icon: <IconVerfuegbarkeitsschnittstelle />,
            intro: "Visualizzate direttamente i vostri prezzi personalizzati per i ricambi nel vostro sistema cliente tramite l'interfaccia.",
            text: (
                <p>
                    Tramite l'interfaccia di disponibilità è possibile visualizzare le quantità disponibili dei ricambi
                    necessari. Non solo, oltre a visualizzare la disponibilità del proprio punto di assistenza, potete
                    vedere anche quella dell'intera catena di fornitura.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'I vantaggi per voi',
                    list: [
                        'Completa trasparenza sulla disponibilità dei ricambi presso il vostro centro di assistenza OMNIplus',
                        "Mostra la disponibilità lungo l'intera catena logistica",
                        'Migliore pianificazione nel processo di approvvigionamento',
                        'Accesso con interfaccia API REST',
                    ],
                },
            ],
            images: {
                main: imageVerfuegbarkeitsschnittstelle,
            },
        },
        [Pages.BESTELLSCHNITTSTELLE]: {
            headline: "Interfaccia d'ordine",
            icon: <IconBestellschnittstelle />,
            intro: 'Inviare gli ordini direttamente a OMNIplus.',
            text: (
                <p>
                    L'integrazione di un'interfaccia per gli ordini di acquisto consente di trasmettere gli ordini
                    direttamente al sistema OMNIplus. Ciò significa che non c'è alcuno scambio di sistema quando si
                    ordina nel sistema cliente. Non è necessario trasferire manualmente i contenuti dell'ordine, che,
                    quindi viene elaborato più velocemente e con precisione. Attualmente è possibile stabilire un
                    collegamento tramite un'interfaccia con i centri di assistenza Daimler Buses con la classificazione
                    BusWorld.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'I vantaggi per voi',
                    list: [
                        'Approvvigionamento digitale dei ricambi senza discontinuità di sistema',
                        "Elaborazione più rapida dell'ordine grazie alla creazione diretta dell'ordine nel Daimler Buses Service Center",
                        "Possibilità di trasmettere una conferma d'ordine tramite l'interfaccia",
                        "Varietà di collegamenti: possibilità di connessione sulla base degli standard EDI, cXML o di un'interfaccia API REST",
                    ],
                },
            ],
            images: {
                main: imageBestellschnittstelle,
            },
        },
        [Pages.KATALOGSCHNITTSTELLE]: {
            headline: 'Interfaccia del catalogo',
            icon: <IconKatalogschnittstelle />,
            intro: 'Facile identificazione dei ricambi necessari senza lasciare il vostro sistema.',
            text: (
                <p>
                    Tramite l'interfaccia del catalogo è possibile identificare i ricambi nell' eShop di OMNIplus e
                    trasferirli nel vostro sistema. Nel catalogo dell'eShop di OMNIplus sono visibili i vostri prezzi
                    personalizzati e la disponibilità presso il proprio punto di assistenza OMNIplus.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'I vantaggi per voi',
                    list: [
                        "Integrazione del parco veicoli specifico del cliente nell'eShop di OMNIplus",
                        'Disponibilità e prezzi personalizzati di cui si può prendere visione direttamente',
                        'Ricerca dei ricambi in quattro modi diversi, ad esempio, utilizzando la documentazione del veicolo nel catalogo BusParts',
                        'Supporta gli standard OCI e cXML',
                    ],
                },
            ],
            images: {
                main: imageKatalogschnittstelle,
            },
        },
        [Pages.NETTOPREISSCHNITTSTELLE]: {
            headline: 'Interfaccia del prezzo netto',
            icon: <IconNettopreisschnittstelle />,
            intro: "Visualizzate direttamente i vostri prezzi personalizzato per i ricambi nel vostro sistema cliente tramite l'interfaccia.",
            text: (
                <>
                    <p>
                        Tramite l'interfaccia dei prezzi netti è possibile trasferire i prezzi dei ricambi direttamente
                        dal sistema OMNIplus al proprio sistema cliente. Nel fare ciò si tiene conto delle condizioni
                        specifiche del cliente e delle promozioni speciali. La richiesta dei prezzi è possibile in tutti
                        i Service Center propri di Daimler Buses con la classificazione BusWorld.
                    </p>
                </>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'I vantaggi per voi',
                    list: [
                        'Visualizzazione del prezzo tenendo conto delle condizioni individuali relativamente ai ricambi pianificati',
                        'Trasparenza completa dei prezzi anche per prezzi speciali e sconti scaglionati',
                        'Possibilità di completare il processo di ordine e di approvazione nel vostro sistema',
                        'Accesso con interfaccia API REST',
                    ],
                },
            ],
            images: {
                main: imageNettopreisschnittstelle,
            },
        },
    },
    processPages: {
        [Pages.TEILEIDENTIFIKATION]: {
            headline: "Identificazione dei componenti tramite l'interfaccia del catalogo",
            headlineWidth: 940,
            infoBox: {
                headline: 'Applicazione',
                bullets: [
                    'State cercando un ricambio per il vostro veicolo, ma non conoscete il codice del ricambio da ordinare? Ad esempio, perché avete a che fare con un nuovo modello di veicolo o perché il pezzo di ricambio richiesto non è stato memorizzato nel vostro database?',
                ],
            },
            steps: [
                {
                    imageUrl: processStepTeileidentifikation1Svg,
                    headline: "Accesso al catalogo dell'eShop di OMNIplus",
                    content: (
                        <>
                            Il catalogo dell'eShop di OMNIplus può essere consultato all'interno del proprio sistema ERP
                            per avviare l'identificazione dei ricambi.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation2Svg,
                    headline: "Identificazione dei componenti tramite l'eShop di OMNIplus",
                    content: (
                        <>
                            Nell'interfaccia dell'eShop è possibile identificare il ricambio necessario in quattro modi
                            diversi. Oltre all'integrazione del parco veicoli individuale, l'eShop offre, ad esempio,
                            anche la ricerca dei ricambi sulla base della documentazione del veicolo nel catalogo
                            BusParts.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation3Svg,
                    headline: 'Trasferimento al sistema del cliente',
                    content:
                        "Dopo aver identificato i ricambi necessari e riempito il carrello degli acquisti, le informazioni sui componenti possono essere trasferite dall'eShop di OMNIplus al sistema cliente.",
                },
                {
                    imageUrl: processStepTeileidentifikation4Svg,
                    headline: 'Ordine di acquisto dal sistema cliente',
                    content: (
                        <>
                            Tramite l'interfaccia d'ordine, con un semplice clic l'ordine di acquisto viene trasmesso al
                            sistema OMNIplus e può essere evaso direttamente.
                        </>
                    ),
                },
            ],
        },
        [Pages.LAGERERGAENZUNG]: {
            headline:
                "Disponibilità dei pezzi di ricambio tramite l'utilizzo dello stato attuale delle scorte e l'interfaccia dei prezzi",
            headlineWidth: 1520,
            infoBox: {
                headline: 'Applicazione',
                bullets: [
                    'In molti casi si è già a conoscenza di quali ricambi sono necessari.',
                    "Ciò si verifica, ad esempio, quando l'identificazione dei ricambi avviene già in officina e nel sistema viene creato un ordine di acquisto con i codici necessari.",
                    <>
                        Oppure, si riceve una notifica nel sistema ERP che segnala che i singoli pezzi hanno raggiunto
                        il livello minimo di scorte. Se i codici del fornitore sono già stati inseriti nel database, è
                        possibile avviare il riapprovvigionamento.
                    </>,
                ],
            },
            steps: [
                {
                    imageUrl: processStepLagerergaenzung1Svg,
                    headline: 'Disponibilità di parti di ricambio comuni da acquistare', // #AB1-Disposition-eProcurement-Click-Explainer#
                    content:
                        'Nel vostro sistema ERP, potete programmare i pezzi di ricambio necessari in un ordine di acquisto, ad esempio per fare scorte.',
                },
                {
                    imageUrl: processStepLagerergaenzung2Svg,
                    headline: 'Visualizzazione della disponibilità e del prezzo',
                    content: (
                        <>
                            Dopo aver creato un ordine di acquisto nel vostro sistema cliente con i ricambi da
                            acquistare, è possibile visualizzare le relative disponibilità e i relativi prezzi tramite
                            l'interfaccia eProcurement.
                        </>
                    ),
                },
                {
                    imageUrl: processStepLagerergaenzung3Svg,
                    headline: "Verifica dell'ordine di acquisto",
                    content:
                        'Nel vostro sistema cliente potete visualizzare le informazioni richieste sulla disponibilità dei ricambi comuni ed eventualmente avviare i processi di approvazione interni.',
                },
                {
                    imageUrl: processStepLagerergaenzung4Svg,
                    headline: 'Ordine di acquisto dal vostro sistema',
                    content:
                        "Successivamente, tramite l'interfaccia d'ordine, è possibile trasmettere l'ordine al sistema OMNIplus in modo che possa essere evaso direttamente.",
                },
            ],
        },
    },
};
